import React from "react";
import { HowWorks } from "../components/Screen1/HowWorks/HowWorks";
import Referral from "../components/Screen1/Referral/Referral";

const Screen1 = () => {
  return (
    <div>
      <Referral />
      <HowWorks />
    </div>
  );
};

export default Screen1;
